import CREATE_FREE_TAG_SPEC_ITEM from './createFreeTagSpecItem.graphql'
export default CREATE_FREE_TAG_SPEC_ITEM
